import React from 'react';
import { motion } from 'framer-motion';
import { Gift, BookOpen } from 'lucide-react';
import { Button } from './ui/Button';
export function ValueStack() {
  const bonuses = [{
    title: 'Somatic Morning Video Library',
    value: 97
  }, {
    title: "The Trader Joe's & Whole Foods List",
    value: 47
  }, {
    title: 'The Hormone-Safe Starbucks Guide',
    value: 27
  }, {
    title: "The 'Wired but Tired' Audio Reset",
    value: 37
  }, {
    title: 'Cortisol-Friendly Workout Plan',
    value: 67
  }, {
    title: 'The Supplement Cheat Sheet',
    value: 47
  }, {
    title: 'The 2-Min Emergency Bloat Fix',
    value: 33
  }];
  return <section id="pricing" className="py-24 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-110">
      <div className="max-w-3xl mx-auto" data-id="element-111">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-112">
          <h2 className="text-sm font-bold tracking-widest text-coral-500 uppercase mb-4" data-id="element-113">
            The "Stupid" Value Stack
          </h2>
          <h3 className="text-3xl sm:text-4xl font-display font-bold text-charcoal-800 mb-6" data-id="element-114">
            When you grab The Cortisol Code today, you're not just getting a
            book.
          </h3>
          <p className="text-xl text-charcoal-700/80" data-id="element-115">
            You're getting the entire Acceleration Bundle:
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7,
        delay: 0.1
      }} className="mb-12" data-id="element-116">
          <img src="https://cdn.magicpatterns.com/uploads/bmLzktqG3cLft5rVu6MAEL/mockup_bonus.png" alt="The Cortisol Code digital platform — accessible on laptop, tablet, and phone" className="w-full rounded-2xl shadow-lg" data-id="element-117" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-cream rounded-3xl p-8 sm:p-10 border border-cream-dark shadow-xl" data-id="element-118">
          <div className="flex items-center justify-between pb-6 border-b border-charcoal-700/10 mb-6" data-id="element-119">
            <div className="flex items-center gap-3" data-id="element-120">
              <BookOpen className="w-6 h-6 text-sage-500" data-id="element-121" />
              <span className="text-xl font-bold text-charcoal-800" data-id="element-122">
                The Cortisol Code Main Guide
              </span>
            </div>
            <span className="text-charcoal-700/50 line-through font-medium" data-id="element-123">
              ($197 Value)
            </span>
          </div>

          <div className="space-y-4 mb-8" data-id="element-124">
            {bonuses.map((bonus, index) => <div key={index} className="flex items-center justify-between" data-id="element-125">
                <div className="flex items-center gap-3" data-id="element-126">
                  <Gift className="w-5 h-5 text-coral-400" data-id="element-127" />
                  <span className="text-charcoal-700 font-medium" data-id="element-128">
                    Bonus #{index + 1}: {bonus.title}
                  </span>
                </div>
                <span className="text-charcoal-700/50 line-through text-sm" data-id="element-129">
                  (${bonus.value} Value)
                </span>
              </div>)}
          </div>

          <div className="bg-white rounded-2xl p-6 sm:p-8 text-center border border-sage-400/20 shadow-sm" data-id="element-130">
            <p className="text-charcoal-700/60 font-medium mb-2" data-id="element-131">
              TOTAL VALUE: <span className="line-through" data-id="element-132">$552</span>
            </p>
            <p className="text-sm font-bold tracking-widest text-coral-500 uppercase mb-2" data-id="element-133">
              YOUR PRICE TODAY
            </p>
            <p className="text-6xl font-display font-bold text-charcoal-800 mb-8" data-id="element-134">
              $27
            </p>

            <Button variant="urgent" size="xl" fullWidth data-id="element-135">
              YES! RESET MY CORTISOL NOW FOR $27
            </Button>
            <p className="mt-4 text-sm text-charcoal-700/60" data-id="element-136">
              Immediate Digital Access • One-time payment • No subscriptions
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}